import React, { useEffect, useState } from "react";
import { fetchMyPageData  } from "../../api/members";
import { changePhone } from "../../api/auth";
import { showToast } from "../common/components/Toast";
import { useNavigate } from "react-router-dom";

const MyPage = () => {
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser).user : null;
  const accountId = user?.id;  // ✅ account_id를 직접 가져오기
  const [transactions, setTransactions] = useState([]);
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(false);
  const [newPhoneNumber, setNewPhoneNumber] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [isChangingPhone, setIsChangingPhone] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!accountId) {
      console.error("❌ MyPage: accountId가 없습니다.");
      navigate("/login");  // ✅ 로그인 안 되어 있으면 로그인 페이지로 이동
      return;
    }

    console.log("🚀 MyPage 데이터 요청 시작 - accountId:", accountId);
    fetchMyPageData(accountId)
      .then((data) => {
        if (data) {
          console.log("✅ MyPage 데이터 로드 완료:", data);
          setMember(data.member);
          setTransactions(data.transactions);
        }
      })
      .catch((error) => {
        console.error("❌ MyPage 데이터 로드 실패:", error);
      });
  }, [accountId, navigate]);


// const MyPage = ({ user }) => {
//   const [transactions, setTransactions] = useState([]);
//   const [member, setMember] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
  
//   useEffect(() => {
//     if (!user) {
//       navigate("/login");
//       return;
//     }

//     console.log("🚀 MyPage 데이터 요청 시작 - user.id:", user.id);

//     // ✅ 회원 정보 및 결제 내역 불러오기
//     const loadMyPageData = async () => {
//       setLoading(true);
//       const data = await fetchMyPageData(user.id);
//       console.log("🔥 fetchMyPageData 응답:", data);
//       if (data) {
//         setMember(data.member);
//         setTransactions(data.transactions);
//       }
//       setLoading(false);
//     };

//     loadMyPageData();
//   }, [user, navigate]);

  const convertToKST = (utcDate) => {
    if (!utcDate) return "시간 정보 없음"; // 값이 없으면 기본값 처리
    return new Date(utcDate).toLocaleString("ko-KR", { timeZone: "Asia/Seoul" });
  };

  const handleChangePhone = async () => {
    if (isChangingPhone) return;
    setIsChangingPhone(true);
    try {
      const data = await changePhone(newPhoneNumber, currentPassword);
      showToast(data.message || "전화번호가 변경되었습니다.", "success");
      setNewPhoneNumber("");
      setCurrentPassword("");
    } catch (error) {
      console.error("❌ 전화번호 변경 실패:", error.response?.data?.message || error.message);
      showToast(error.response?.data?.message || "전화번호 변경에 실패했어요. 다시 시도해 주세요.", "fail");
    } finally {
      setIsChangingPhone(false);
    }
  };

  return (
    <div className="p-6 px-4 md:px-[160px] lg:px-[200px]">
      {/* 🔹 회원 정보 */}
      {loading ? (
        <p>로딩 중...</p>
      ) : !member ? (
        <p className="text-red-500">회원 정보를 불러올 수 없습니다.</p>
      ) : (
        <>
          <div className="mb-6 bg-white p-4 rounded-lg shadow">
            <h2 className="text-lg font-bold">현재 보유 포인트</h2>
            <p className="text-2xl font-bold text-blue-500">{(member.points ?? 0).toLocaleString()}p</p>
          </div>

          {/* 🔹 거래 내역 */}
          {transactions.length === 0 ? (
            <p className="text-gray-500">거래 내역이 없습니다.</p>
          ) : (
            transactions.map((txn) => {
              const adjustment = txn.adjustment ? parseFloat(txn.adjustment) : 0;
              const adjustmentReason = txn.adjustment_reason ?? ""; // 🚀 조정 사유 기본값
              const storeName = txn.store_name ?? "매장 정보 없음"; // 🚀 매장 정보 기본값

              return(
                <div key={txn.id} className="p-4 bg-white rounded-lg shadow">
                  <h3 className="text-lg font-semibold">구매한 상품</h3>
                  <ul>
                    {txn.items.map((item) => (
                      <li key={item.product_id} className="flex justify-between">
                        <span>{item.name} x {item.quantity}</span>
                        <span>{((item.price ?? 0) * (item.quantity ?? 1)).toLocaleString()}원</span>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-3">
                    <p>총 결제 금액: <span className="font-bold">{Math.floor((txn.final_amount ?? 0)).toLocaleString()}원</span></p>
                    <p>사용 포인트: <span className="text-red-500">{Math.floor((txn.discount ?? 0)).toLocaleString()}p</span></p>
                    <p>적립 포인트: <span className="text-green-500">{Math.floor((txn.earned_points ?? 0)).toLocaleString()}p</span></p>
                    <p>결제 수단: <span className="text-gray-600">{txn.payment_method || "정보 없음"}</span></p>
                  <p>결제장소: <span className="">{txn.store_name}</span></p>
                    <p className="text-gray-500 text-sm">{convertToKST(txn.created_at)}</p>
                    
                    {/* ✅ 조정 금액 & 사유 (조정 금액이 0이 아닐 때만 출력) */}
                    {adjustment !== 0 && (
                      <div className="mt-3 p-3 border rounded-lg bg-gray-100">
                        <span className={`font-bold ${adjustment > 0 ? "text-green-600" : "text-red-600"}`}>
                          {adjustment > 0 ? "🔺 추가 금액" : "🔻 할인 금액"}:{" "}
                          {Math.floor(adjustment).toLocaleString()}원
                        </span>
                        {adjustmentReason && (
                          <p className="text-gray-600 text-sm mt-1">사유: {adjustmentReason}</p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          )}

          {/* 🔹 전화번호 변경 */}
          <div className="mt-6 mb-6 bg-white p-4 rounded-lg shadow">
            <h2 className="text-lg font-bold">전화번호 변경</h2>
            <p className="text-sm text-gray-500 mt-1 mb-4">변경 후 다음 로그인부터 새 번호가 아이디입니다.</p>
            <div className="flex flex-col gap-1 mb-4">
              <label className="block font-500 text-sm text-gray-900">새 전화번호</label>
              <input
                type="tel"
                value={newPhoneNumber}
                onChange={(e) => setNewPhoneNumber(e.target.value.replace(/\D/g, "").slice(0, 11))}
                placeholder="숫자만 입력하세요"
                pattern="\d*"
                className="w-full px-6 py-3 text-base text-gray-900 font-400 border border-gray-900 rounded-2xl placeholder:text-base placeholder:text-gray-400"
              />
            </div>
            <div className="flex flex-col gap-1 mb-4">
              <label className="block font-500 text-sm text-gray-900">현재 비밀번호</label>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                placeholder="현재 비밀번호를 입력하세요"
                className="w-full px-6 py-3 text-base text-gray-900 font-400 border border-gray-900 rounded-2xl placeholder:text-base placeholder:text-gray-400"
              />
            </div>
            <button
              onClick={handleChangePhone}
              disabled={!newPhoneNumber || !currentPassword || isChangingPhone}
              className={`w-full px-6 py-3 rounded-2xl text-base ${
                newPhoneNumber && currentPassword && !isChangingPhone
                  ? "bg-gray-900 text-white"
                  : "bg-gray-100 text-gray-500 cursor-not-allowed"
              }`}
            >
              {isChangingPhone ? "처리 중..." : "전화번호 변경"}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default MyPage;